let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("czBH9")).then(() => parcelRequire('9HyOS'));